<template>
  <v-card class="mb-2">
    <v-toolbar dense color="primary" dark>
      <v-toolbar-title>
        <v-icon color="yellow">mdi-star</v-icon>
        What's New</v-toolbar-title
      >
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-card>
      <v-card-title>Marketing Tools</v-card-title>
      <v-card-text class="text-body-1">
        <p>
          We are implementing a suite of marketing tools to help customers promote their
          favourite products.
        </p>
        <p>
          To start with we have provided a feature to download asset files and images for
          our recently updated range of fine art Giclee Editions.
        </p>
        <router-link to="/customer/marketing/images">Latest Giclee Editions</router-link>
      </v-card-text>
    </v-card>
  </v-card>
</template>

<script>
import clickApi from "@/api/public/click";

export default {
  props: {},
  data() {
    return {
      imageUrl: `${process.env.VUE_APP_IMG_URL}/300px/`,
      products: [
        { category: "Coasters", image: "Coasters.jpg" },
        { category: "Framed Tiles", image: "Framed-Tiles.jpg" },
        { category: "Glass Chopping Boards", image: "Glass-Chopping-Boards.jpg" },
        {
          category: "Stretched Canvases (Framed)",
          image: "Stretched-Canvases---Framed.jpg",
        },
        { category: "Wood Panel Boards", image: "Wood-Panel-Boards.jpg" },
      ],
    };
  },
  computed: {},
  created: async function () {},
  mounted: function () {},
  methods: {
    getImage(image) {
      return require("@/assets/" + image);
    },
    goToProduct(category) {
      const obj = {};
      obj.category = [category];
      this.$store.commit("filters/resetFilters");
      this.$store.commit("filters/setFilters", obj);
      this.$router.push("/catalog").catch((err) => {
        return err !== null;
      });
    },
    async goToProducts() {
      const obj = {
        category: [
          "Coaster",
          "Framed Tile",
          "Glass Chopping Board",
          "Stretched Canvas (Framed)",
          "Wood Panel Board",
        ],
        artist: ["Janet McCrorie"],
      };
      this.$store.commit("filters/resetFilters");
      this.$store.commit("filters/setFilters", obj);
      this.$router.push("/catalog").catch((err) => {
        return err !== null;
      });
    },
  },
};
</script>
